import { reportError } from '@ms/yammer-telemetry';
import type { Store } from 'redux';

import type { YammerState } from '../../state/types';
import { getCurrentNetworkId, getCurrentSessionUserField } from '../session/selectors';

import { pruneModeratedEventAgentReplyReplacements } from './replacementStorage';

export const initializeReplacementStorageMaintenance = (
  store: Pick<Store<YammerState>, 'getState' | 'subscribe'>
): (() => void) => {
  let previousUserId: string | undefined;
  let previousNetworkId: string | undefined;
  let isInitialized = false;
  const maintainStorage = () => {
    const state = store.getState();
    const userId = getCurrentSessionUserField(state, 'id');
    const networkId = getCurrentNetworkId(state);
    if (!isInitialized && (!userId || !networkId)) {
      return;
    }

    if (isInitialized && userId === previousUserId && networkId === previousNetworkId) {
      return;
    }

    isInitialized = true;
    previousUserId = userId;
    previousNetworkId = networkId;
    try {
      pruneModeratedEventAgentReplyReplacements(state);
    } catch (error) {
      reportError({ error });
    }
  };
  maintainStorage();

  return store.subscribe(maintainStorage);
};
